import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  fetchCartAddons,
  setCartStage,
  showLoader,
} from "../../../redux/actions/cartAction";
import { obWorkshop } from "../../../lib/config";
import {
  gtmChooseCheckout,
  gtmChooseProceed,
  gtmChooseSkip,
} from "../../../lib/google-tag-manager";
import CommonModel from "components/common/CommonModel";
import InfoIcon from "@assets/images/info.svg";
import Image from "next/image";
import { useRouter } from "next/router";
import { setLoader } from "redux/actions/globalAction";
import { MdInfoOutline } from "react-icons/md";

const CartBottomArea = ({
  cart,
  setCartStage,
  globalData,
  fetchCartAddons,
  apiData,
  showLoader,
}) => {
  const [showtabby, setShowtabby] = useState(false);
  const [tabbyModel, setTabbyModel] = useState(false);
  const router = useRouter();

  let total = 0;
  let discountPrice = 0;
  let totalServicesWithOffer = 0;

  useEffect(() => {
    const SHOW_TABBY_PAY = total > 450;
    setShowtabby(
      SHOW_TABBY_PAY && process.env.NEXT_PUBLIC_ACTIVE_TABBY_PAYMENT
    );
  }, [cart]);
  const freeOilChange = JSON.parse(
    localStorage.getItem("freeOilData") || JSON.stringify("")
  );

  if (router.query.slug && router.query.slug[1] == "tyre") {
    const tyreProduct = JSON.parse(
      localStorage.getItem("tyreProduct") || JSON.stringify("")
    );
    if (tyreProduct && tyreProduct.length > 0) {
      tyreProduct.map((item) => {
        total += item.Cost;
      });
    }
  } else {
    cart.jobItems.map((item) => {
      if (
        cart.appliedCartOffers &&
        ((cart.appliedCartOffers.PromotionType != "WorkshopProductPromotion" &&
          cart.appliedCartOffers.PromotionType != "WorkshopPromotion") ||
          ((cart.appliedCartOffers.PromotionType ==
            "WorkshopProductPromotion" ||
            cart.appliedCartOffers.PromotionType == "WorkshopPromotion") &&
            cart.appliedCartOffers?.isOfferWorkshopSelected))
      ) {
        const isOfferAvailable =
          item.Offers && item?.Offers.length
            ? item.Offers.filter(
                (offer) =>
                  offer.PromotionId == cart.appliedCartOffers.PromotionId
              ).length
            : false;
        if (isOfferAvailable) {
          const discountPercentage = cart?.appliedCartOffers
            ?.PromotionPercentValue
            ? parseFloat(cart?.appliedCartOffers?.PromotionPercentValue)
            : 0;
          const d_amount = (parseFloat(item.Cost) * discountPercentage) / 100;
          const flatvalue = parseFloat(
            cart?.appliedCartOffers?.PromotionFlatValue
              ? cart?.appliedCartOffers?.PromotionFlatValue
              : 0
          );

          const remainingValue = d_amount + flatvalue;
          discountPrice += remainingValue;
        } // totalServicesWithOffer += 1;
      }
      if (
        freeOilChange &&
        freeOilChange?.JourneyVariantName == item.JourneyVariantName
      ) {
        total += 0;
      } else {
        total += item.Cost;
      }
    });

    cart.addedAddons.map((item) => {
      total += item.Cost;
    });

    cart.addedPackages.map((item) => {
      total += item.Cost;
    });

    if (cart.addMembership && apiData.levelupMembership) {
      total += apiData.levelupMembership.Cost;
    }
  }
  useEffect(() => {
    if (cart.workshop) {
      cart.products.map((variant) =>
        fetchCartAddons(
          cart.workshop.Id,
          variant.Id,
          globalData.carData?.modelId
        )
      );
    }
  }, [cart.products]);

  const handleNextClick = () => {
    setCartStage(3);
    cart.products.map((variant) =>
      fetchCartAddons(
        variant.IslandType === obWorkshop
          ? apiData.defaultWorkshop?.Id
          : cart.workshop.Id,
        variant.Id,
        globalData.carData?.modelId
      )
    );
  };
  const handleNextClickButton = () => {
    setCartStage(2);
  };
  return (
    <div className="grey-cart-block price-strip-height">
      <CommonModel
        istabby={true}
        show={tabbyModel}
        onHide={() => {
          setTabbyModel(false);
        }}
      >
        <iframe
          id="tabby-installment-iframe"
          src="https://checkout.tabby.ai/promos/product-page/installments/en/"
          height="546px"
          width="100%"
          style={{ borderWidth: 0 }}
        ></iframe>
      </CommonModel>
      <div className="checkout-btm-tp price-strip-mb">
        <div
          className={`ad-val-chk flex-column ${
            cart.appliedCartOffers ? "ad-val-chk-height" : ""
          }`}
        >
          <h4>
            {discountPrice ? (
              <>
                AED{" "}
                <del className="mr-1 offer-applied-ui">
                  {parseFloat(total).toFixed(2)}
                </del>
              </>
            ) : (
              `AED ${parseFloat(total).toFixed(2)}`
            )}
            {discountPrice
              ? `${parseFloat(
                  total -
                    discountPrice *
                      (totalServicesWithOffer != 0 ? totalServicesWithOffer : 1)
                ).toFixed(2)}`
              : null}{" "}
            <span>(VAT Extra)</span>
          </h4>
          {!cart.appliedCartOffers ? (
            <label>Offers Available at Checkout</label>
          ) : null}
        </div>
        {(cart.addedPackages.length !== 0 || cart.jobItems.length !== 0) && (
          <>
            {cart.stage === 2 &&
            cart.addedPackages.length !== 0 &&
            cart.jobItems.length === 0 ? (
              <button
                onClick={() => {
                  showLoader(true);
                  gtmChooseCheckout("CHECKOUT");
                  router.push("/checkout");
                }}
                className="checkout-btm-buttom glare-animation"
              >
                CHECKOUT
              </button>
            ) : (
              <>
                {cart.stage === 4 ? (
                  <button
                    onClick={() => {
                      showLoader(true);
                      gtmChooseCheckout("CHECKOUT");
                      router.push("/checkout");
                    }}
                    className="checkout-btm-buttom glare-animation"
                  >
                    CHECKOUT
                  </button>
                ) : cart.stage === 3 ? (
                  <button
                    className={`checkout-btm-buttom glare-animation ${
                      cart.addons === null ? "disabled" : ""
                    }`}
                    style={cart.addedAddons.length ? {} : { width: "118px" }}
                    onClick={() => {
                      if (cart.addedAddons.length) {
                        gtmChooseProceed("PROCEED");
                      } else {
                        gtmChooseSkip("SKIP");
                      }
                      setCartStage(4);
                    }}
                    disabled={cart.addons == null}
                  >
                    {cart.addedAddons.length ? "Proceed" : "Skip"}
                  </button>
                ) : cart.stage === 1 ? (
                  <button
                    onClick={() => {
                      gtmChooseCheckout("NEXT");
                      handleNextClickButton();
                    }}
                    className="checkout-btm-buttom glare-animation"
                  >
                    Proceed
                  </button>
                ) : (
                  <button
                    onClick={() => {
                      gtmChooseCheckout("CHECKOUT");
                      handleNextClick();
                    }}
                    className="checkout-btm-buttom glare-animation"
                  >
                    {/* Addons */}
                    Proceed
                  </button>
                )}
              </>
            )}
          </>
        )}
      </div>
      {showtabby ? (
        <div className="tby-block-ft-bar">
          <small>
            <img src="/assets/images/tabby.webp" alt="Tabby" />{" "}
          </small>
          <p>
            Split in 4 interest-free payments of{" "}
            <strong>
              AED &nbsp;AED&nbsp;{parseFloat(total).toFixed(0) / 4}{" "}
            </strong>
            / month
            <i
              style={{ paddingLeft: "2px" }}
              onClick={() => {
                setTabbyModel(true);
              }}
            >
              <MdInfoOutline size={14} />
            </i>
          </p>
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    cart: state.cart,
    globalData: state.globalData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCartStage: (stage) => {
      dispatch(setCartStage(stage));
    },
    fetchCartAddons: (workshopId, variantId, carModeId) => {
      dispatch(fetchCartAddons(workshopId, variantId, carModeId));
    },
    showLoader: (show) => {
      dispatch(setLoader(show));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CartBottomArea);
